module.exports = __webpack_public_path__ + "static/media/step-one.45dfde71.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/step-one.JPG
// module id = 1071
// module chunks = 0